<table class='table table-silver'>
  <thead>
  <tr>
    <th style='width: 30rem'>
      <span class="sr-only">Nazwa</span>
    </th>
    <th>
      Powierzchnia
    </th>
  </tr>
  </thead>
  <tbody>
  <tr>
    <td class='align-left p-2'>
      <strong>
        W ciągu dróg powiatowych
      </strong>
    </td>
    <td>
      {{ stage?.devicesCountyRoadsArea | toNumber | number }} m<sup>2</sup>
    </td>
  </tr>
  <tr>
    <td class='align-left p-2'>
      <strong>
        Na obiekcie mostowym
      </strong>
    </td>
    <td>
      {{ stage?.devicesOnBridgeArea | toNumber | number }} m<sup>2</sup>
    </td>
  </tr>
  <tr>
    <td class='align-left p-2'>
      <strong>
        Obiektów i urządzeń infrastruktury telekomunikacyjnej
      </strong>
    </td>
    <td>
      {{ stage?.infrastructureEquipmentArea | toNumber | number }} m<sup>2</sup>
    </td>
  </tr>
  </tbody>
</table>
